import { App } from 'vue';
import permission from './permission';
import autoSize from './autoSize';
import throttle from './throttle';
import authority from './authority';
import authorityToast from './authorityToast';
import showTooltip from './showTooltip';

export default {
  install(Vue: App) {
    Vue.directive('permission', permission);
    Vue.directive('auto-size', autoSize);
    Vue.directive('throttle', throttle);
    Vue.directive('authority', authority);
    Vue.directive('authority-toast', authorityToast);
    Vue.directive('show-tooltip', showTooltip);
  },
};
